import React from 'react';
export function PathThread({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex flex-col items-center justify-center py-8 ${className}`} data-id="element-402">
      <div className="w-3 h-3 rounded-full bg-seaglass shadow-[0_0_10px_rgba(139,168,159,0.5)]" data-id="element-403"></div>
      <div className="w-0.5 h-24 bg-gradient-to-b from-seaglass to-transparent opacity-50" data-id="element-404"></div>
    </div>;
}